import {
  Box,
  Divider,
  Fab,
  Grid,
  IconButton,
  Paper,
  TableRow,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  add_user_transaction,
  get_transaction_list,
} from "../Redux/Actions/action";
import ErrorHandler, {
  capitalizeFirstLetterOfWords,
  PaymentStatus,
} from "../Utils/handler";
import { showLoader } from "../Redux/Slices/loaderSlice";
import { toast } from "react-toastify";
import CommonTable from "../Components/Common/CommonTable";
import StyledTableCell from "../Components/Common/styledTableCell";
import DataNotFound from "../Components/Common/DataNotFound";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CommonDatePicker from "../Components/Common/CommonDatePicker";
import CustomPagination from "../Components/Common/CommonPagination";
import dayjs from "dayjs";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import SimCardDownloadOutlinedIcon from "@mui/icons-material/SimCardDownloadOutlined";
import ExcelJS from "exceljs";
import * as FileSaver from "file-saver";
import CommonSearchField from "../Components/Common/CommonSearchField";
import InfoIcon from "@mui/icons-material/Info";
import { useConfirm } from "material-ui-confirm";
import CommonDropDown from "../Components/Common/CommonDropDown";
import PaperCommon from "../Components/Common/PaperCommon";
import TextLabel from "../Components/Common/CommonTextLabel";
const tableHeaders = [
  "No",
  "Full Name",
  "PPSK-ID",
  "Phone Number",
  "Aadhaar Number",
  "Receipt No",
  "Transaction Date",
  "Transaction Id",
  "Payer Name",
  "Modify By",
  "Status",
  "Action",
];

const AllTransaction = () => {
  // ---------- Hook -----------
  const theme = useTheme();
  const dispatch = useDispatch();
  const confirmDialogue = useConfirm();

  // --------------- State -------------
  const [transactionHistory, setTransactionHistory] = React.useState();
  const [data, setData] = React.useState({ status: "All", startDate: "", endDate: "" });
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [searchText, setSearchText] = React.useState("");

  // ----- handleChange -----
  const handleChangePage = (e, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 25));
    setPage(1);
  };

  const _generateExcel = (data) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet 1");

    const headerRowValues = [
      "No",
      "PPSK-ID",
      "Receipt No",
      "Full Name",
      "Transaction Date",
      "Transaction ID",
      "Phone Number",
      "Aadhaar Number",
      "Dob",
      "Amount",
      "Status",
      "VerificationStatus",
    ];
    const headerRow = worksheet.addRow(headerRowValues);

    headerRow.eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "3e4094" }, // Background color
      };
      cell.font = { bold: true, color: { argb: "FFFFFF" } }; // White text, bold font
    });
    // Add data rows
    data?.forEach((val, index) => {
      worksheet.addRow([
        index + 1,
        val?.ppskId || "-",
        val?.receiptNo || "-",
        val?.fullName || "-",
        dayjs(val?.transactionDate).format("lll") || "-",
        val?.transactionId || "-",
        val?.phoneNumber || "-",
        val?.aadhaarNumber || "-",
        dayjs(val?.dob).format("ll") || "-",
        val?.amount || "-",
        val?.status || "-",
        val?.verificationStatus || "-",
      ]);
    });

    worksheet.columns = [
      { width: 10 },
      { width: 18 },
      { width: 25 },
      { width: 40 },
      { width: 20 },
      { width: 30 },
      { width: 20 },
      { width: 20 },
      { width: 10 },
      { width: 15 },
      { width: 20 },
    ];
    // Save workbook to file
    workbook.xlsx
      .writeBuffer()
      .then((buffer) => {
        const data = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        FileSaver.saveAs(
          data,
          `${`Transaction History ${dayjs(new Date()).format("DD/MM/YYYY")}`}`
        );
      })
      .catch((err) => {
        console.error("Error generating Excel:", err);
      });
  };

  const _downloadAllTransactionHistory = async () => {
    let body = {
      search: searchText || "",
      startDate: data?.startDate
        ? dayjs(data?.startDate)?.format?.("DD/MM/YYYY")
        : "",
      endDate: data?.endDate
        ? dayjs(data?.endDate)?.format?.("DD/MM/YYYY")
        : "",
      status: data?.status
    };
    dispatch(showLoader(true));
    try {
      const result = await dispatch(get_transaction_list(body));
      const error = ErrorHandler(result);
      if (error) {
        // console.log(result?.payload?.data, "sasdataa")
        _generateExcel(result?.payload?.data?.response);
      }
    } catch (error) {
      toast.error(error);
    } finally {
      dispatch(showLoader(false));
    }
  };

  // --------------- Api  ---------------
  const _getAllTransactionHistory = async () => {
    let body = {
      search: searchText || "",
      page: page,
      limit: rowsPerPage,
      startDate: data?.startDate
        ? dayjs(data?.startDate)?.format?.("DD/MM/YYYY")
        : "",
      endDate: data?.endDate
        ? dayjs(data?.endDate)?.format?.("DD/MM/YYYY")
        : "",
      status: data?.status
    };
    dispatch(showLoader(true));
    try {
      const result = await dispatch(get_transaction_list(body));
      const error = ErrorHandler(result);
      if (error) {
        setTransactionHistory(result?.payload?.data);
      }
    } catch (error) {
      toast.error(error);
    } finally {
      dispatch(showLoader(false));
    }
  };

  // ---------- useEffect ---------
  useEffect(() => {
    // if()
    _getAllTransactionHistory();
  }, [data, page, rowsPerPage, searchText]);

  const _add_user_transaction = async (id) => {
    let body = {
      transactionId: id || "",
    };
    dispatch(showLoader(true));
    try {
      const result = await dispatch(add_user_transaction(body));
      const error = ErrorHandler(result);
      if (error) {
        toast.success(result?.payload?.message);
        _getAllTransactionHistory();
      }
    } catch (error) {
      toast.error(error);
    } finally {
      dispatch(showLoader(false));
    }
  };

  return (
    <>
      <Grid container spacing={2} xs={12} sm={12} md={12} lg={12}>
        <Grid item xs={12}>
          <Paper
            elevation={0}
            sx={{ padding: 2, background: { md: "#fff", xs: "none" } }}
          >
            <Box
              display={"flex"}
              justifyContent={"space-between"}
              flexWrap={"wrap"}
              mb={1}
              alignItems={"center"}
            >
              <Typography
                sx={{ fontSize: { lg: 24, md: 20, xs: 18 } }}
                fontWeight={"medium"}
                color={"#3E4094"}
              >
                Transaction History
              </Typography>
              <Box>
                <Box display={"flex"} alignItems={"self-start"} gap={1}>
                  <Box>
                    <CommonDropDown
                      text={"Status"}
                      name={"status"}
                      value={data?.status}
                      values={
                        [{ label: "All", value: "All" }, { label: "Success", value: "Success" }, { label: "Failure", value: "Failure" }]?.map((val) => val?.value)
                      }
                      width={"150px"}
                      onChange={(e) => setData({ ...data, status: e.target.value })}
                      notShowSelect
                    />
                  </Box>
                  <CommonDatePicker
                    name={"startDate"}
                    label={"From Date"}
                    onChange={(e) => {
                      setData({ ...data, startDate: e });
                    }}
                    value={data?.startDate ? data?.startDate : null}
                  />
                  <CommonDatePicker
                    name={"endDate"}
                    label={"To Date"}
                    onChange={(e) => {
                      setData({ ...data, endDate: e });
                    }}
                    value={data?.endDate ? data?.endDate : null}
                    disabled={!data?.startDate}
                    minDate={data?.startDate || null}
                  />
                  {data?.startDate && data?.endDate && (
                    <IconButton sx={{ padding: 0, marginTop: 3 }}>
                      <CloseOutlinedIcon
                        color="error"
                        onClick={() => {
                          setData({ status: data?.status, startDate: "", endDate: "" });
                        }}
                      />
                    </IconButton>
                  )}
                  {/* <Tooltip title="Download Transaction History">
                                        <Fab disabled={transactionHistory?.response?.length === 0} sx={{ width: '30px', height: '30px', boxShadow: 'none', minHeight: "30px", padding: 0 }} onClick={() => _downloadAllTransactionHistory()} color="primary">
                                            <SimCardDownloadOutlinedIcon sx={{ fontSize: '20px' }} />
                                        </Fab>
                                    </Tooltip> */}
                </Box>
                <Box
                  display={"flex"}
                  justifyContent={"flex-end"}
                  alignItems={"center"}
                  gap={1}
                  my={1.5}
                >
                  <CommonSearchField
                    placeholder={"Search.."}
                    tooltipList={[
                      "Full Name",
                      "Phone Number",
                      "PPSK Id",
                      "Receipt No",
                    ]}
                    handleSearch={(e) => {
                      setPage(1);
                      setSearchText(e);
                    }}
                  />

                  <Tooltip title="Download Transaction History">
                    <Fab
                      disabled={transactionHistory?.response?.length === 0}
                      sx={{
                        width: "30px",
                        height: "30px",
                        boxShadow: "none",
                        minHeight: "30px",
                        padding: 0,
                      }}
                      onClick={() => _downloadAllTransactionHistory()}
                      color="primary"
                    >
                      <SimCardDownloadOutlinedIcon sx={{ fontSize: "20px" }} />
                    </Fab>
                  </Tooltip>
                </Box>
              </Box>
            </Box>
            <Grid container item spacing={2} xs={12} mb={2}>
              <Grid item xs={12} sm={6} md={4}>
                <PaperCommon
                  borderRadius={'16px'}
                  padding={'15px'}
                  boxShadow={"rgba(0, 0, 0, 0.24) 0px 3px 8px;"}
                  contant={<CountUi title={"PPSK Active Members"} count={transactionHistory?.ppskActiveMembersCount} />}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <PaperCommon
                  borderRadius={'16px'}
                  padding={'15px'}
                  boxShadow={"rgba(0, 0, 0, 0.24) 0px 3px 8px;"}
                  contant={<CountUi title={"PPSK Payment Success"} count={transactionHistory?.ppskPaymentSuccessCount} />}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4}>
                <PaperCommon
                  borderRadius={'16px'}
                  padding={'15px'}
                  boxShadow={"rgba(0, 0, 0, 0.24) 0px 3px 8px;"}
                  contant={<CountUi title={"SRK Payment Success"} count={transactionHistory?.srkPaymentSuccessCount} />}
                />
              </Grid>
            </Grid>
            <CommonTable
              headerList={tableHeaders}
              align={"center"}
              minWidth={600}
            >
              {transactionHistory?.response?.length > 0 ? (
                transactionHistory?.response?.map((val, index) => {
                  return (
                    <TableRow key={index}>
                      <StyledTableCell align="center">
                        {index + 1 || "-"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {capitalizeFirstLetterOfWords(val?.fullName) || "-"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {val?.ppskId || "-"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {val?.phoneNumber || "-"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {val?.aadhaarNumber || "-"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {val?.receiptNo || "-"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {dayjs(val?.transactionDate).format("lll") || "-"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {val?.transactionId || "-"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {/* <Typography sx={{ textTransform: 'capitalize' }}> {val?.payerName || "-"}</Typography> */}
                        {capitalizeFirstLetterOfWords(val?.payerName) || "-"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {val?.modifiedBy || "-"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <PaymentStatus
                          label={val?.status}
                          status={val?.status}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {val?.status?.toLowerCase() === "failure" ||
                          val?.status?.toLowerCase() === "cancel" ? (
                          <InfoIcon
                            color="primary"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              confirmDialogue({
                                title: `Are you sure you want to change the transaction status?`,
                                confirmationText: "Yes",
                                cancellationText: "No",
                              })
                                .then(() => {
                                  _add_user_transaction(val?.transactionId);
                                })
                                .catch((err) => { });
                            }}
                          />
                        ) : (
                          ""
                        )}
                      </StyledTableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <StyledTableCell colSpan={11}>
                    <DataNotFound
                      title={"No Records Found"}
                      icon={
                        <ErrorOutlineIcon
                          color="primary"
                          style={{ fontSize: "3rem" }}
                        />
                      }
                      elevation={0}
                    />
                  </StyledTableCell>
                </TableRow>
              )}
            </CommonTable>

            {transactionHistory?.count > 0 && (
              <Grid item xs={12}>
                <CustomPagination
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  count={Math.ceil(transactionHistory?.count / rowsPerPage)}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Grid>
            )}
          </Paper>
        </Grid>
      </Grid>
    </>
  );
};

export default AllTransaction;


const CountUi = ({ title, count }) => {
  return (
    <>
      <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} flexWrap={'wrap'} >
        <Box display={'flex'} flexDirection={'row'} alignItems={'center'} gap={0.8}>
          <TextLabel title={title} fontSize={{ xs: "9px", sm: "12px" }} lineHeight={"29.11px"} fontWeight={'bold'} />
        </Box>
      </Box>
      <Divider />
      <Typography variant="h4" fontWeight={600} sx={{ color: "#3E4094" }}>
        {count}
      </Typography>
    </>
  )
}
